import React from 'react';

const InputsSections = ({ children }) => {
	return <div className='modalContainer__form--sections'>{children}</div>;
};

export default InputsSections;
